<template>
  <a-modal
    :title="title"
    :width="1200"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="EMPI">
              {{model.empi}}
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              prop="idcard"
              label="身份证号">
              <a-input placeholder="请输入身份证号" :disabled="isView" v-model="model.idcard"  @blur="idcardBlur"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              prop="name"
              label="姓名">
              <a-input placeholder="请输入姓名" v-model="model.name" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="性别" prop="sex">
              <a-radio-group  v-model="model.sex" button-style="solid" :disabled="!!model.idcard || isView">
                <a-radio-button value="1">
                  男
                </a-radio-button>
                <a-radio-button value="0">
                  女
                </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" prop="birthDay">
            <a-form-model-item label="出生日期">
              <a-date-picker
                :disabled="!!model.idcard || isView"
                style="width: 100%"
                placeholder="请选择出生日期"
                valueFormat="YYYY-MM-DD"
                allowClear
                v-model="model.birthDay"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="年龄" prop="age">
              <a-input-number v-model="model.age" :disabled="!!model.idcard || isView" :min="0" :max="130"  placeholder="请输入年龄"  :precision="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="备注" prop="description">
              <a-textarea :disabled="isView" placeholder="请输入备注" :rows="2" v-model="model.description"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="联系方式1" prop="teleType1">
              <a-select :disabled="isView" v-model="model.teleType1"  allowClear placeholder="请选择" >
                <a-select-option :value="item.value"  v-for="(item,index) in teleTypeList" :key="index">{{item.text}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="" prop="telephone1">
              <a-input :disabled="isView" placeholder="请输入联系号码1" v-model="model.telephone1" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="联系方式2" >
              <a-select :disabled="isView" v-model="model.teleType2"  allowClear placeholder="请选择" >
                <a-select-option :value="item.value"  v-for="(item,index) in teleTypeList" :key="index">{{item.text}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="" prop="telephone2">
              <a-input :disabled="isView" placeholder="请输入联系号码2" v-model="model.telephone2" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="联系方式3" >
              <a-select :disabled="isView" v-model="model.teleType3"  allowClear placeholder="请选择" >
                <a-select-option :value="item.value"  v-for="(item,index) in teleTypeList" :key="index">{{item.text}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="" prop="telephone3">
              <a-input :disabled="isView" placeholder="请输入联系号码3" v-model="model.telephone3" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>

      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import {checkID} from '@/constants/baseRules'
  import {idcardInfo} from '@/utils/patientInput'
  import baseRules from '@/constants/baseRules'

  export default {
    name: "EmpiModal",
    components: { ATextarea },
    props:{
      isView:{
        type:Boolean,
        default:false
      }
    },
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        confirmLoading: false,

        url: {
          add: "/management/empi/add",
          edit: "/management/empi/edit",
        },
        teleTypeList:[
          {value:'1',text:'本人'},
          {value:'2',text:'配偶'},
          {value:'3',text:'子女'},
          {value:'4',text:'父母'},
          {value:'5',text:'朋友'},
          {value:'6',text:'其他亲戚'},
          {value:'9',text:'其他'},
        ],
        rules:{
          idcard:[baseRules.idcard],
          telephone1:[baseRules.phone],
          telephone2:[baseRules.phone],
          telephone3:[baseRules.phone],
        },
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        if(this.isView){
          that.close();
          return
        }
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.empi){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = this.model;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      idcardBlur(){
        if(this.model.idcard && checkID(this.model.idcard)){
          this.$set(this.model,'birthDay',idcardInfo(this.model.idcard,1))
          this.$set(this.model,'sex',idcardInfo(this.model.idcard,2))
          this.$set(this.model,'age',idcardInfo(this.model.idcard,3))
          // this.$set(this.record,'description',idcardArea.getAreaByIdCard(this.record.idcard))
        }
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style lang="less" scoped>

</style>